import React from 'react';
import {MultistoreMenuItem} from "../../../../../../../utils/types";
import {useTranslation} from "react-i18next";
import {MenuProductViewType} from "../../../../../../../../../services/Api/types";
import AppConfig from "../../../../../../../../../services/AppConfig";
import {ReactComponent as MenuItemDarkIco} from "../../../../../../../../../../images/icons/menus/menu-item-dark.svg";
import {ReactComponent as MenuItemIco} from "../../../../../../../../../../images/icons/menus/menu-item.svg";
import {ReactComponent as PlusIco} from "../../../../../../../../../../images/icons/plus.svg";
import RoundedIcon from "../../../../../../../../../components/Common/RoundedIcon";
import Money from "../../../../../../../../../components/Common/Money";
import Utils from "../../../../../../../../../utils/Utils";

interface Props {
    product: MultistoreMenuItem;
    viewType: MenuProductViewType;
    onClick: () => void;
}

const MultistoreMenuCategoryProduct = ({product, viewType, onClick}: Props) => {
    const {t} = useTranslation();

    const getItemImageLink = () => {
        switch (viewType) {
            case MenuProductViewType.VERTICAL_BIG_IMAGE:
                return product.image_medium;
            case MenuProductViewType.HORIZONTAL:
            case MenuProductViewType.VERTICAL_SMALL_IMAGE:
            default:
                return product.image_small;
        }
    }

    const drawPrice = () => {
        return product.price.amount > 0 ? (
            <span className="price price-bottom">
                    <Money value={product.price.amount} currency={product.price.currency}/>
            </span>
        ) : <></>;
    }

    return (
        <div className="menu-item" onClick={onClick}>
            <div className="card">
                <div className="card-img">
                    <div>
                        {
                            getItemImageLink() ? <img src={getItemImageLink()}
                                                      alt={t("common.word.product_image")}/> : AppConfig.isDarkMode() ?
                                <MenuItemDarkIco className="image-svg"/> : <MenuItemIco className="image-svg"/>
                        }
                        <div className="rounded-icons-container">
                            <RoundedIcon size="small" icon={<PlusIco/>}
                                         forceEllipseInDarkMode={viewType === MenuProductViewType.VERTICAL_BIG_IMAGE ? true : undefined}
                                         className={viewType === MenuProductViewType.VERTICAL_BIG_IMAGE ? "" : "text-primary"}/>
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    {
                        viewType === MenuProductViewType.VERTICAL_SMALL_IMAGE && (
                            <h1 className="card-title">{product.name}</h1>
                        )
                    }
                    {
                        (viewType === MenuProductViewType.HORIZONTAL || viewType === MenuProductViewType.VERTICAL_BIG_IMAGE) && (
                            <>
                                {drawPrice()}
                                <h1 className="card-title">{product.name}</h1>
                            </>
                        )
                    }
                    {
                        product.description && (
                            <p className="card-text"
                               dangerouslySetInnerHTML={{__html: Utils.nl2brString(product.description)}}/>
                        )
                    }
                    {
                        viewType === MenuProductViewType.VERTICAL_SMALL_IMAGE && (
                            drawPrice()
                        )
                    }
                </div>
            </div>
        </div>
    )
}

export default MultistoreMenuCategoryProduct;